import React, { useEffect, useState } from "react";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import Typography from "@material-ui/core/Typography";
import useStyles from "./style";
import { Divider } from "@material-ui/core";
import { useData } from "../../../../components/firebase/DataProvider";

function Alamat({ id, subcart }) {
  const classes = useStyles();
  const { alamat } = useData();
  const [selectedAlamat, setSelectedAlamat] = useState({});
  
  useEffect(() => {
    if (id) {
      const findAlamat = alamat.find((al) => al.id === id);
      if (findAlamat) {
        setSelectedAlamat(findAlamat);
      }
    }
  }, [id, alamat]);

  return (
    <>
      <div>
        <Divider style={{ height: "5px", backgroundColor: "#5675D3" }} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", padding: "10px" }}>
            <div style={{ marginRight: "10px" }}>
              <RoomOutlinedIcon />
            </div>
            <div>
              <Typography className={classes.liquidPrimaryBold}>
                Alamat Pengiriman
              </Typography>
              {selectedAlamat?.nama_penerima ? (
                <>
                  <Typography className={classes.liquidSmall}>
                    {selectedAlamat?.nama_penerima} {selectedAlamat?.no_telepon}
                  </Typography>
                  <Typography className={classes.liquidSmall}>
                    {selectedAlamat?.alamat_lengkap}, Kec.{" "}
                    {selectedAlamat?.kecamatan?.name}, Kel.{" "}
                    {selectedAlamat?.kelurahan?.name}, Kota{" "}
                    {selectedAlamat?.kota?.name},{" "}
                    {selectedAlamat?.provinsi?.name}
                  </Typography>
                </>
              ) : (
                <Typography className={classes.liquidSmall}>
                  Alamat Pengiriman Belum Dipilih
                </Typography>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Alamat;
